module.exports = __webpack_public_path__ + "assets/img/activity-over-btn.324aec6e.png";